/**
 * FilterChip - Reusable filter toggle button
 *
 * Used across filter panels for toggling filter states.
 */
import clsx from 'clsx';
import type { ReactElement } from 'react';

export interface FilterChipProps {
  /** Display label */
  label: string;
  /** Whether the filter is active */
  isActive: boolean;
  /** Click handler */
  onClick: () => void;
  /** Optional className for additional styling */
  className?: string;
  title?: string;
}

export default function FilterChip({ label, isActive, onClick, className, title }: FilterChipProps): ReactElement {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={clsx(
        'rounded-full px-2.5 py-1 text-xs font-medium transition-all',
        'focus-visible:ring-aether focus-visible:ring-offset-void focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none',
        isActive ? 'bg-aether text-white' : 'bg-slate text-silver hover:bg-storm hover:text-pearl',
        className,
      )}
      aria-pressed={isActive}
      aria-label={`Filter by ${label}`}
    >
      {label}
    </button>
  );
}
